import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { List, ListItem, ListItemIcon, Typography } from '@mui/material';
import clsx from 'clsx';
import { IUsersWithAccessItem } from 'services/businessPlan/types';

import { ReactComponent as AccountIcon } from 'assets/icons/AccountIcon.svg';

import { Button } from 'components/_basic/Button/Button';

import styles from './InviteAssistantsModal.module.scss';

interface IProps {
  usersList?: IUsersWithAccessItem[];
  removeEditor: (email: string) => Promise<void>;
}

export const AssistantsList: FC<IProps> = memo(({ usersList = [], removeEditor }) => {
  const { t } = useTranslation();

  return (
    <List className={styles.editorsList}>
      <Typography variant="subtitle2">{t('editors')}</Typography>
      {usersList.map(({ email }, index) => {
        const isFirstItem = index === 0;

        return (
          <ListItem className={styles.editorsListItem} key={email}>
            <ListItemIcon className={styles.listIconWrapper}>
              <AccountIcon className={styles.listIcon} />
            </ListItemIcon>
            <Typography variant="h6">{email}</Typography>
            <Button
              disabled={isFirstItem}
              className={clsx(styles.listButton, !isFirstItem && styles.removeButton)}
              variant="text"
              onClick={() => removeEditor(email)}
            >
              {t(isFirstItem ? 'owner' : 'remove')}
            </Button>
          </ListItem>
        );
      })}
    </List>
  );
});
